import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		token: localStorage.getItem('token') || '',
		userInfo: JSON.parse(localStorage.getItem('userInfo') || 'null')
	},
	getters: {
		isLoggedIn: (state) => !!state.token
	},
	mutations: {
		login(state, { token, userInfo }) {
			state.token = token
			state.userInfo = userInfo
			localStorage.setItem('token', token)
			localStorage.setItem('userInfo', JSON.stringify(userInfo))
		},
		setUserInfo(state, userInfo) {
			state.userInfo = userInfo
			localStorage.setItem('userInfo', JSON.stringify(userInfo))
		},
		logout(state) {
			state.token = ''
			state.userInfo = null
			localStorage.removeItem('token')
			localStorage.removeItem('userInfo')
		}
	},
	actions: {}
})
